/* ============================================================
   SUPERMOTO WHEEL CONFIGURATOR V2 — JavaScript
   ============================================================
   Vanilla JS · Finish → Color dependency · Per-wheel config
   No accessories · No SKU in cart/summary
   ============================================================ */

(function () {
  'use strict';

  /* ──────────────────────────────────────────────────────────
     1. CONFIGURATION DATA
     ────────────────────────────────────────────────────────── */

  const bikeData = {
    KTM: {
      '690 SMC R': ['2019','2020','2021','2022','2023','2024'],
      '690 Enduro R': ['2019','2020','2021','2022','2023','2024'],
      'EXC 450': ['2016','2017','2018','2019','2020','2021','2022','2023'],
      'EXC 500': ['2017','2018','2019','2020','2021','2022','2023'],
      'EXC-F 350': ['2020','2021','2022','2023','2024'],
      'SX-F 450': ['2019','2020','2021','2022','2023','2024']
    },
    Husqvarna: {
      '701 Supermoto': ['2019','2020','2021','2022','2023','2024'],
      '701 Enduro': ['2019','2020','2021','2022','2023','2024'],
      'FE 450': ['2020','2021','2022','2023','2024'],
      'FE 350': ['2020','2021','2022','2023','2024'],
      'FC 450': ['2019','2020','2021','2022','2023','2024']
    },
    GASGAS: {
      'SM 700': ['2022','2023','2024'],
      'EC 350 F': ['2021','2022','2023','2024'],
      'EC 450 F': ['2021','2022','2023','2024'],
      'EX 350': ['2022','2023','2024']
    },
    Yamaha: {
      'WR 450 F': ['2019','2020','2021','2022','2023'],
      'YZ 450 F': ['2018','2019','2020','2021','2022','2023'],
      'WR 250 F': ['2020','2021','2022','2023']
    },
    Honda: {
      'CRF 450 R': ['2017','2018','2019','2020','2021','2022','2023'],
      'CRF 450 L': ['2019','2020','2021','2022','2023'],
      'CRF 250 R': ['2018','2019','2020','2021','2022','2023']
    },
    Suzuki: {
      'DR-Z 400 SM': ['2005','2006','2007','2008','2009','2018','2019','2020','2021','2022'],
      'RM-Z 450': ['2018','2019','2020','2021','2022','2023']
    },
    Beta: {
      'RR 390': ['2020','2021','2022','2023'],
      'RR 430': ['2020','2021','2022','2023'],
      'RR 480': ['2020','2021','2022','2023'],
      'RR 350': ['2020','2021','2022','2023']
    },
    Husaberg: {
      'FE 450': ['2009','2010','2011','2012','2013'],
      'FE 501': ['2013','2014'],
      'FS 570': ['2009','2010','2011','2012']
    }
  };

  /* ──────────────────────────────────────────────────────────
     FINISH → COLOR MAPS
     Farben je Finish. Später einfach anpassbar.
     ────────────────────────────────────────────────────────── */

  /** Master color palette – referenced by ID from finishColorMap */
  const allRimColors = [
    { id: 'Black',              label: 'Schwarz',             hex: '#1a1a1a',            type: 'solid' },
    { id: 'Silver',             label: 'Silber',              hex: '#c0c0c0',            type: 'solid' },
    { id: 'Gold',               label: 'Gold',                hex: '#d4a017',            type: 'solid' },
    { id: 'Blue',               label: 'Blau',                hex: '#1e40af',            type: 'solid' },
    { id: 'Red',                label: 'Rot',                 hex: '#dc2626',            type: 'solid' },
    { id: 'Orange',             label: 'Orange',              hex: '#e65100',            type: 'solid' },
    { id: 'Green',              label: 'Grün',                hex: '#16a34a',            type: 'solid' },
    { id: 'Purple',             label: 'Lila',                hex: '#7c3aed',            type: 'solid' },
    { id: 'White',              label: 'Weiß',                hex: '#f5f5f5',            type: 'solid' },
    { id: 'Pink',               label: 'Pink',                hex: '#ec4899',            type: 'solid' },
    { id: 'Turquoise',          label: 'Türkis',              hex: '#06b6d4',            type: 'solid' },
    { id: 'ArcticBlue',         label: 'Arctic Blue',         hex: '#7dd3fc',            type: 'solid' },
    { id: 'White_ArcticBlue',   label: 'Weiß / Arctic Blue',  hex: ['#f5f5f5','#7dd3fc'], type: 'dual' },
    { id: 'Blue_Orange',        label: 'Blau / Orange',        hex: ['#1e40af','#e65100'], type: 'dual' },
    { id: 'Black_Gold',         label: 'Schwarz / Gold',       hex: ['#1a1a1a','#d4a017'], type: 'dual' }
  ];

  const allHubColors = [
    { id: 'Black',   label: 'Schwarz', hex: '#1a1a1a' },
    { id: 'Silver',  label: 'Silber',  hex: '#c0c0c0' },
    { id: 'Gold',    label: 'Gold',    hex: '#d4a017' },
    { id: 'Blue',    label: 'Blau',    hex: '#1e40af' },
    { id: 'Red',     label: 'Rot',     hex: '#dc2626' },
    { id: 'Orange',  label: 'Orange',  hex: '#e65100' },
    { id: 'Green',   label: 'Grün',    hex: '#16a34a' },
    { id: 'Purple',  label: 'Lila',    hex: '#7c3aed' }
  ];

  /**
   * Maps finish → available color IDs.
   * Replace these arrays with your final data later.
   * Currently all colors are available for every finish (placeholder).
   */
  const finishColorMap = {
    rim: {
      Anodized:     ['Black','Silver','Gold','Blue','Red','Orange','Green','Purple','White','Pink','Turquoise','ArcticBlue','White_ArcticBlue','Blue_Orange','Black_Gold'],
      Powdercoated: ['Black','Silver','Gold','Blue','Red','Orange','Green','Purple','White','Pink','Turquoise','ArcticBlue','White_ArcticBlue','Blue_Orange','Black_Gold'],
      Cerakote:     ['Black','Silver','Gold','Blue','Red','Orange','Green','Purple','White','Pink','Turquoise','ArcticBlue','White_ArcticBlue','Blue_Orange','Black_Gold']
    },
    hub: {
      Anodized:     ['Black','Silver','Gold','Blue','Red','Orange','Green','Purple'],
      Powdercoated: ['Black','Silver','Gold','Blue','Red','Orange','Green','Purple'],
      Cerakote:     ['Black','Silver','Gold','Blue','Red','Orange','Green','Purple']
    }
  };

  function getColorsForFinish(component, finishId) {
    const ids = (finishColorMap[component] && finishColorMap[component][finishId]) || [];
    const master = component === 'rim' ? allRimColors : allHubColors;
    return master.filter(c => ids.includes(c.id));
  }

  /* Other option lists */
  const hubManufacturers = [
    { id: 'HAAN',            label: 'HAAN',             cushDrive: false, frontOk: true,  rearOk: true  },
    { id: 'EVSS',            label: 'EVSS',             cushDrive: false, frontOk: true,  rearOk: true  },
    { id: 'SMPro',           label: 'SM Pro',           cushDrive: false, frontOk: true,  rearOk: true  },
    { id: 'HaanCushdrive',   label: 'Haan Cushdrive',   cushDrive: true,  frontOk: false, rearOk: true  },
    { id: 'SMProCushdrive',  label: 'SM Pro Cushdrive', cushDrive: true,  frontOk: false, rearOk: true  }
  ];

  const rimFinishes = [
    { id: 'Anodized',     label: 'Eloxiert' },
    { id: 'Powdercoated', label: 'Pulverbeschichtet' },
    { id: 'Cerakote',     label: 'Cerakote' }
  ];
  const hubFinishes = [
    { id: 'Anodized',     label: 'Eloxiert' },
    { id: 'Powdercoated', label: 'Pulverbeschichtet' },
    { id: 'Cerakote',     label: 'Cerakote' }
  ];

  const spokeColors = [
    { id: 'Black',            label: 'Schwarz',          hex: '#1a1a1a' },
    { id: 'Silver_Stainless', label: 'Silber Edelstahl', hex: '#d1d5db' },
    { id: 'White',            label: 'Weiß',             hex: '#f5f5f5' }
  ];
  const spokeTypes = [
    { id: 'Stainless',   label: 'Edelstahl' },
    { id: 'BlackChrome', label: 'Schwarz verchromt' }
  ];

  const nippleColors = [
    { id: 'Gold',   label: 'Gold',    hex: '#d4a017' },
    { id: 'Silver', label: 'Silber',  hex: '#c0c0c0' },
    { id: 'Black',  label: 'Schwarz', hex: '#1a1a1a' },
    { id: 'Blue',   label: 'Blau',    hex: '#1e40af' },
    { id: 'Red',    label: 'Rot',     hex: '#dc2626' },
    { id: 'Orange', label: 'Orange',  hex: '#e65100' },
    { id: 'Green',  label: 'Grün',    hex: '#16a34a' },
    { id: 'Purple', label: 'Lila',    hex: '#7c3aed' }
  ];
  const nippleTypes = [
    { id: 'Aluminium', label: 'Aluminium' },
    { id: 'Standard',  label: 'Standard' }
  ];

  /* ──────────────────────────────────────────────────────────
     2. PRICING
     ────────────────────────────────────────────────────────── */

  const pricing = {
    base: 934,
    rimColor: {
      _default: 0, Gold: 40, Blue: 40, Red: 40, Orange: 40, Green: 40,
      Purple: 40, Pink: 40, Turquoise: 40, ArcticBlue: 40,
      White_ArcticBlue: 80, Blue_Orange: 80, Black_Gold: 80
    },
    rimFinish: { Anodized: 0, Powdercoated: 60, Cerakote: 120 },
    hubMake:   { HAAN: 80, EVSS: 0, SMPro: 0, HaanCushdrive: 180, SMProCushdrive: 120 },
    hubFinish: { Anodized: 0, Powdercoated: 40, Cerakote: 80 },
    spokeType: { Stainless: 0, BlackChrome: 30 },
    nippleType:{ Aluminium: 25, Standard: 0 }
  };

  function getSurcharge(cat, id) {
    const m = pricing[cat];
    if (!m) return 0;
    return m[id] !== undefined ? m[id] : (m._default || 0);
  }

  function formatEuro(v) {
    return (v || 0).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '\u00a0€';
  }

  /* ──────────────────────────────────────────────────────────
     3. SKU (internal only — never sent to Shopify)
     ────────────────────────────────────────────────────────── */

  function generateSKU(type, pos, ...parts) {
    const segs = [type];
    if (pos) segs.push(pos);
    segs.push(...parts.filter(Boolean).map(p => String(p).replace(/[\s\/]+/g, '')));
    return segs.join('_');
  }

  /* ──────────────────────────────────────────────────────────
     4. STATE — per-wheel spokes & nipples, no accessories
     ────────────────────────────────────────────────────────── */

  const wheelDefaults = () => ({
    rimFinish: 'Anodized', rimColor: 'Black',
    hubMake: 'EVSS', hubFinish: 'Anodized', hubColor: 'Black',
    spokeType: 'Stainless', spokeColor: 'Black',
    nippleType: 'Aluminium', nippleColor: 'Black'
  });

  const state = {
    bike: { make: '', model: '', year: '' },
    front: wheelDefaults(),
    rear:  wheelDefaults(),
    _skus: {},
    pricing: { base: pricing.base, surcharges: {}, total: pricing.base }
  };

  /* ──────────────────────────────────────────────────────────
     5. DOM HELPERS
     ────────────────────────────────────────────────────────── */

  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));

  let section, viewerFrame, viewerPlaceholder, viewerStatusDot, viewerStatusText;
  let summaryBody, priceRows, priceTotal, mobilePrice, addToCartBtn, mobileCartBtn;
  let lineItemPropsContainer, validationMsg;
  let viewerUrl, targetOrigin, variantId;
  let viewerReady = false;
  const messageBuffer = [];

  /* ──────────────────────────────────────────────────────────
     6. INIT
     ────────────────────────────────────────────────────────── */

  function init() {
    section = $('#wheelConfigurator');
    if (!section) return;

    viewerFrame       = $('#wcViewerFrame');
    viewerPlaceholder = $('#wcViewerPlaceholder');
    viewerStatusDot   = $('.wc__viewer-dot');
    viewerStatusText  = $('#wcViewerStatusText');
    summaryBody       = $('#wcSummaryBody');
    priceRows         = $('#wcPriceRows');
    priceTotal        = $('#wcPriceTotal');
    mobilePrice       = $('#wcMobilePrice');
    addToCartBtn      = $('#wcAddToCart');
    mobileCartBtn     = $('#wcMobileCartBtn');
    lineItemPropsContainer = $('#wcLineItemProps');
    validationMsg     = $('#wcValidationMsg');

    viewerUrl    = section.dataset.viewerUrl || '';
    targetOrigin = section.dataset.targetOrigin || '*';
    variantId    = section.dataset.variantId || '';

    setupAccordions();
    setupBikeSelectors();

    // Front wheel controls
    renderPills('wcFrontRimFinish', rimFinishes, 'front', 'rimFinish');
    renderPills('wcFrontHubMake', null, 'front', 'hubMake'); // custom render
    renderHubPills('wcFrontHubMake', 'front');
    renderPills('wcFrontHubFinish', hubFinishes, 'front', 'hubFinish');
    renderSwatches('wcFrontSpokeColors', spokeColors, 'front', 'spokeColor');
    renderPills('wcFrontSpokeTypes', spokeTypes, 'front', 'spokeType');
    renderSwatches('wcFrontNippleColors', nippleColors, 'front', 'nippleColor');
    renderPills('wcFrontNippleTypes', nippleTypes, 'front', 'nippleType');

    // Rear wheel controls
    renderPills('wcRearRimFinish', rimFinishes, 'rear', 'rimFinish');
    renderHubPills('wcRearHubMake', 'rear');
    renderPills('wcRearHubFinish', hubFinishes, 'rear', 'hubFinish');
    renderSwatches('wcRearSpokeColors', spokeColors, 'rear', 'spokeColor');
    renderPills('wcRearSpokeTypes', spokeTypes, 'rear', 'spokeType');
    renderSwatches('wcRearNippleColors', nippleColors, 'rear', 'nippleColor');
    renderPills('wcRearNippleTypes', nippleTypes, 'rear', 'nippleType');

    // Rim & hub colors are rendered dynamically after finish selection
    // (containers start empty + locked)

    setupViewerIframe();
    setupResetButton();
    setupCartForm();
    applyDefaultSelections();
    recalculate();
  }

  /* ──────────────────────────────────────────────────────────
     7. ACCORDIONS
     ────────────────────────────────────────────────────────── */

  function setupAccordions() {
    $$('.wc__card-header').forEach(btn => {
      btn.addEventListener('click', () => {
        const exp = btn.getAttribute('aria-expanded') === 'true';
        const body = $('#' + btn.getAttribute('aria-controls'));
        if (!body) return;
        btn.setAttribute('aria-expanded', String(!exp));
        body.classList.toggle('wc__card-body--collapsed', exp);
      });
    });
  }

  /* ──────────────────────────────────────────────────────────
     8. BIKE SELECTORS
     ────────────────────────────────────────────────────────── */

  function setupBikeSelectors() {
    const makeEl  = $('#wcBikeMake');
    const modelEl = $('#wcBikeModel');
    const yearEl  = $('#wcBikeYear');

    Object.keys(bikeData).sort().forEach(m => {
      const o = document.createElement('option');
      o.value = m; o.textContent = m;
      makeEl.appendChild(o);
    });

    makeEl.addEventListener('change', () => {
      state.bike.make = makeEl.value;
      state.bike.model = ''; state.bike.year = '';
      modelEl.innerHTML = '<option value="">— Modell wählen —</option>';
      yearEl.innerHTML  = '<option value="">— Baujahr wählen —</option>';
      modelEl.disabled = !makeEl.value; yearEl.disabled = true;
      if (makeEl.value && bikeData[makeEl.value]) {
        Object.keys(bikeData[makeEl.value]).sort().forEach(mod => {
          const o = document.createElement('option');
          o.value = mod; o.textContent = mod;
          modelEl.appendChild(o);
        });
      }
      recalculate();
      sendMsg('SET_BIKE', { ...state.bike });
    });

    modelEl.addEventListener('change', () => {
      state.bike.model = modelEl.value; state.bike.year = '';
      yearEl.innerHTML = '<option value="">— Baujahr wählen —</option>';
      yearEl.disabled = !modelEl.value;
      if (state.bike.make && modelEl.value && bikeData[state.bike.make]?.[modelEl.value]) {
        bikeData[state.bike.make][modelEl.value].forEach(y => {
          const o = document.createElement('option');
          o.value = y; o.textContent = y;
          yearEl.appendChild(o);
        });
      }
      recalculate();
      sendMsg('SET_BIKE', { ...state.bike });
    });

    yearEl.addEventListener('change', () => {
      state.bike.year = yearEl.value;
      recalculate();
      sendMsg('SET_BIKE', { ...state.bike });
    });
  }

  /* ──────────────────────────────────────────────────────────
     9. SWATCH RENDERING (static — for spokes, nipples)
     ────────────────────────────────────────────────────────── */

  function renderSwatches(containerId, colorList, stateGroup, stateKey) {
    const container = $('#' + containerId);
    if (!container) return;
    container.innerHTML = '';

    colorList.forEach(c => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'wc__swatch' + (c.type === 'dual' ? ' wc__swatch--dual' : '');
      btn.setAttribute('role', 'radio');
      btn.setAttribute('aria-checked', 'false');
      btn.setAttribute('aria-label', c.label);
      btn.dataset.colorId = c.id;

      if (c.type === 'dual' && Array.isArray(c.hex)) {
        const h1 = document.createElement('span'); h1.className = 'wc__swatch-half'; h1.style.background = c.hex[0];
        const h2 = document.createElement('span'); h2.className = 'wc__swatch-half'; h2.style.background = c.hex[1];
        btn.appendChild(h1); btn.appendChild(h2);
      } else {
        btn.style.background = c.hex;
      }

      const tip = document.createElement('span');
      tip.className = 'wc__swatch-tooltip'; tip.textContent = c.label;
      btn.appendChild(tip);

      btn.addEventListener('click', () => {
        $$('.wc__swatch', container).forEach(s => s.setAttribute('aria-checked', 'false'));
        btn.setAttribute('aria-checked', 'true');
        state[stateGroup][stateKey] = c.id;
        recalculate();

        // Viewer events
        if (stateKey === 'spokeColor') {
          sendMsg('SET_SPOKES', { target: stateGroup, color: c.id, hex: c.hex, type: state[stateGroup].spokeType });
        } else if (stateKey === 'nippleColor') {
          sendMsg('SET_NIPPLES', { target: stateGroup, color: c.id, hex: c.hex, type: state[stateGroup].nippleType });
        }
      });

      container.appendChild(btn);
    });
  }

  /* ──────────────────────────────────────────────────────────
     10. DYNAMIC SWATCH RENDERING (finish-dependent — rim/hub colors)
     ────────────────────────────────────────────────────────── */

  function renderFinishDependentColors(component, position) {
    // component: 'rim' | 'hub'
    // position: 'front' | 'rear'
    const prefix = position.charAt(0).toUpperCase() + position.slice(1);
    const capComp = component.charAt(0).toUpperCase() + component.slice(1);
    const containerId = `wc${prefix === 'Front' ? 'Front' : 'Rear'}${capComp === 'Rim' ? 'Rim' : 'Hub'}Colors`;
    const hintId      = `wc${prefix === 'Front' ? 'Front' : 'Rear'}${capComp === 'Rim' ? 'Rim' : 'Hub'}ColorHint`;
    const stateKey    = component === 'rim' ? 'rimColor' : 'hubColor';
    const finishKey   = component === 'rim' ? 'rimFinish' : 'hubFinish';

    const container = $('#' + containerId);
    const hint      = $('#' + hintId);
    if (!container) return;

    const finishVal = state[position][finishKey];

    // Reset current color selection
    state[position][stateKey] = '';

    if (!finishVal) {
      container.innerHTML = '';
      container.classList.add('wc__swatches--locked');
      if (hint) { hint.classList.remove('is-hidden'); hint.textContent = component === 'rim' ? 'Bitte zuerst das Finish wählen' : 'Bitte zuerst das Naben-Finish wählen'; }
      recalculate();
      return;
    }

    // Get available colors for this finish
    const colors = getColorsForFinish(component, finishVal);

    container.innerHTML = '';
    container.classList.remove('wc__swatches--locked');
    if (hint) hint.classList.add('is-hidden');

    colors.forEach(c => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'wc__swatch' + (c.type === 'dual' ? ' wc__swatch--dual' : '');
      btn.setAttribute('role', 'radio');
      btn.setAttribute('aria-checked', 'false');
      btn.setAttribute('aria-label', c.label);
      btn.dataset.colorId = c.id;

      if (c.type === 'dual' && Array.isArray(c.hex)) {
        const h1 = document.createElement('span'); h1.className = 'wc__swatch-half'; h1.style.background = c.hex[0];
        const h2 = document.createElement('span'); h2.className = 'wc__swatch-half'; h2.style.background = c.hex[1];
        btn.appendChild(h1); btn.appendChild(h2);
      } else {
        btn.style.background = c.hex;
      }

      const tip = document.createElement('span');
      tip.className = 'wc__swatch-tooltip'; tip.textContent = c.label;
      btn.appendChild(tip);

      btn.addEventListener('click', () => {
        $$('.wc__swatch', container).forEach(s => s.setAttribute('aria-checked', 'false'));
        btn.setAttribute('aria-checked', 'true');
        state[position][stateKey] = c.id;
        recalculate();

        // Viewer events
        if (component === 'rim') {
          if (c.type === 'dual') {
            sendMsg('SET_RIM_FADE', { target: position, primary: c.hex[0], secondary: c.hex[1], colorId: c.id, finish: finishVal });
          } else {
            sendMsg('SET_RIM', { target: position, color: c.id, hex: c.hex, finish: finishVal });
          }
        } else {
          sendMsg('SET_HUB', { target: position, manufacturer: state[position].hubMake, color: c.id, hex: c.hex, finish: finishVal });
        }
      });

      container.appendChild(btn);
    });

    recalculate();
  }

  /* ──────────────────────────────────────────────────────────
     11. PILLS (generic + hub-specific)
     ────────────────────────────────────────────────────────── */

  function renderPills(containerId, options, stateGroup, stateKey) {
    if (!options) return; // hub pills handled separately
    const container = $('#' + containerId);
    if (!container) return;
    container.innerHTML = '';

    options.forEach(opt => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'wc__pill';
      btn.setAttribute('role', 'radio');
      btn.setAttribute('aria-checked', 'false');
      btn.setAttribute('aria-label', opt.label);
      btn.dataset.optionId = opt.id;
      btn.textContent = opt.label;

      const sur = getSurcharge(stateKey, opt.id);
      if (sur > 0) {
        const badge = document.createElement('span');
        badge.className = 'wc__pill-badge';
        badge.textContent = '+' + sur + '€';
        btn.appendChild(badge);
      }

      btn.addEventListener('click', () => {
        if (btn.getAttribute('aria-disabled') === 'true') return;
        $$('.wc__pill', container).forEach(p => p.setAttribute('aria-checked', 'false'));
        btn.setAttribute('aria-checked', 'true');
        state[stateGroup][stateKey] = opt.id;

        // If this is a finish change, rebuild the dependent color swatches
        if (stateKey === 'rimFinish') {
          renderFinishDependentColors('rim', stateGroup);
          sendMsg('SET_FINISH', { target: stateGroup, component: 'rim', finish: opt.id });
        } else if (stateKey === 'hubFinish') {
          renderFinishDependentColors('hub', stateGroup);
          sendMsg('SET_FINISH', { target: stateGroup, component: 'hub', finish: opt.id });
        } else if (stateKey === 'spokeType') {
          sendMsg('SET_SPOKES', { target: stateGroup, color: state[stateGroup].spokeColor, type: opt.id });
        } else if (stateKey === 'nippleType') {
          sendMsg('SET_NIPPLES', { target: stateGroup, color: state[stateGroup].nippleColor, type: opt.id });
        }

        recalculate();
      });

      container.appendChild(btn);
    });
  }

  function renderHubPills(containerId, position) {
    const container = $('#' + containerId);
    if (!container) return;
    container.innerHTML = '';

    hubManufacturers.forEach(hub => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'wc__pill';
      btn.setAttribute('role', 'radio');
      btn.setAttribute('aria-checked', 'false');
      btn.dataset.optionId = hub.id;

      const ok = position === 'front' ? hub.frontOk : hub.rearOk;
      if (!ok) {
        btn.setAttribute('aria-disabled', 'true');
        btn.title = 'Nicht verfügbar für ' + (position === 'front' ? 'Vorderrad' : 'Hinterrad');
      }

      btn.textContent = hub.label;

      if (hub.cushDrive) {
        const t = document.createElement('span'); t.className = 'wc__pill-badge'; t.textContent = 'Cushdrive';
        btn.appendChild(t);
      }
      const sur = getSurcharge('hubMake', hub.id);
      if (sur > 0) {
        const b = document.createElement('span'); b.className = 'wc__pill-badge'; b.textContent = '+' + sur + '€';
        btn.appendChild(b);
      }

      btn.addEventListener('click', () => {
        if (!ok) return;
        $$('.wc__pill', container).forEach(p => p.setAttribute('aria-checked', 'false'));
        btn.setAttribute('aria-checked', 'true');
        state[position].hubMake = hub.id;
        recalculate();
        sendMsg('SET_HUB', { target: position, manufacturer: hub.id, color: state[position].hubColor, cushDrive: hub.cushDrive });
      });

      container.appendChild(btn);
    });
  }

  /* ──────────────────────────────────────────────────────────
     12. RECALCULATE
     ────────────────────────────────────────────────────────── */

  function recalculate() {
    computeSKUs();
    computePricing();
    renderSummary();
    renderPricing();
    validateForm();
    updateBadges();
  }

  function computeSKUs() {
    const s = state._skus;
    ['front','rear'].forEach(pos => {
      const w = state[pos];
      s[`rim_${pos}`]    = w.rimColor  ? generateSKU('Felgenring', pos === 'front' ? 'Front' : 'Rear', w.rimColor) : '';
      s[`hub_${pos}`]    = (w.hubMake && w.hubColor) ? generateSKU('Hub', pos === 'front' ? 'Front' : 'Rear', w.hubMake, w.hubColor) : '';
      s[`spokes_${pos}`] = w.spokeColor ? generateSKU('Spokes', pos === 'front' ? 'Front' : 'Rear', w.spokeColor, w.spokeType) : '';
      s[`nipples_${pos}`]= w.nippleColor ? generateSKU('Nipples', pos === 'front' ? 'Front' : 'Rear', w.nippleColor, w.nippleType) : '';
    });
  }

  function computePricing() {
    const surcharges = {};
    let total = pricing.base;

    ['front','rear'].forEach(pos => {
      const label = pos === 'front' ? 'Vorderrad' : 'Hinterrad';
      const w = state[pos];

      const rc = getSurcharge('rimColor', w.rimColor);
      if (rc)  { surcharges[label + ' Felgenfarbe'] = rc; total += rc; }
      const rf = getSurcharge('rimFinish', w.rimFinish);
      if (rf)  { surcharges[label + ' Felgen-Finish'] = rf; total += rf; }
      const hm = getSurcharge('hubMake', w.hubMake);
      if (hm)  { surcharges[label + ' Nabe'] = hm; total += hm; }
      const hf = getSurcharge('hubFinish', w.hubFinish);
      if (hf)  { surcharges[label + ' Naben-Finish'] = hf; total += hf; }
      const st = getSurcharge('spokeType', w.spokeType);
      if (st)  { surcharges[label + ' Speichentyp'] = st; total += st; }
      const nt = getSurcharge('nippleType', w.nippleType);
      if (nt)  { surcharges[label + ' Nippeltyp'] = nt; total += nt; }
    });

    state.pricing = { base: pricing.base, surcharges, total };
  }

  /* ──────────────────────────────────────────────────────────
     13. SUMMARY (no SKUs)
     ────────────────────────────────────────────────────────── */

  function renderSummary() {
    if (!summaryBody) return;

    const hasAny = state.bike.make || state.front.rimFinish || state.rear.rimFinish;
    if (!hasAny) {
      summaryBody.innerHTML = '<div class="wc__summary-empty">Beginne mit der Konfiguration, um eine Übersicht zu sehen.</div>';
      return;
    }

    const lbl = (list, id) => { const i = list.find(x => x.id === id); return i ? i.label : (id || '—'); };
    let html = '';

    if (state.bike.make) {
      html += sec('Fahrzeug', [
        row('Hersteller', state.bike.make),
        row('Modell', state.bike.model || '—'),
        row('Baujahr', state.bike.year || '—')
      ]);
    }

    ['front','rear'].forEach(pos => {
      const title = pos === 'front' ? 'Vorderrad' : 'Hinterrad';
      const w = state[pos];
      const rows = [];

      if (w.rimFinish)   rows.push(row('Felgenring Finish', lbl(rimFinishes, w.rimFinish)));
      if (w.rimColor)    rows.push(row('Felgenring Farbe', lbl(allRimColors, w.rimColor)));
      if (w.hubMake)     rows.push(row('Nabenhersteller', lbl(hubManufacturers, w.hubMake)));
      if (w.hubFinish)   rows.push(row('Naben-Finish', lbl(hubFinishes, w.hubFinish)));
      if (w.hubColor)    rows.push(row('Nabenfarbe', lbl(allHubColors, w.hubColor)));
      if (w.spokeType)   rows.push(row('Speichentyp', lbl(spokeTypes, w.spokeType)));
      if (w.spokeColor)  rows.push(row('Speichenfarbe', lbl(spokeColors, w.spokeColor)));
      if (w.nippleType)  rows.push(row('Nippeltyp', lbl(nippleTypes, w.nippleType)));
      if (w.nippleColor) rows.push(row('Nippelfarbe', lbl(nippleColors, w.nippleColor)));

      if (rows.length) html += sec(title, rows);
    });

    summaryBody.innerHTML = html;
  }

  function sec(title, rows) {
    return `<div class="wc__summary-section"><div class="wc__summary-section-title">${title}</div>${rows.join('')}</div>`;
  }
  function row(k, v) {
    return `<div class="wc__summary-row"><span class="wc__summary-key">${k}</span><span class="wc__summary-val">${v}</span></div>`;
  }

  /* ──────────────────────────────────────────────────────────
     14. PRICING DISPLAY
     ────────────────────────────────────────────────────────── */

  function renderPricing() {
    if (!priceRows || !priceTotal) return;
    let html = `<div class="wc__price-row"><span class="wc__price-row-label">Basispreis</span><span class="wc__price-row-value">${formatEuro(state.pricing.base)}</span></div>`;
    for (const [label, amt] of Object.entries(state.pricing.surcharges)) {
      html += `<div class="wc__price-row wc__price-row--surcharge"><span class="wc__price-row-label">${label}</span><span class="wc__price-row-value">+${formatEuro(amt)}</span></div>`;
    }
    priceRows.innerHTML = html;
    priceTotal.innerHTML = formatEuro(state.pricing.total);
    if (mobilePrice) mobilePrice.innerHTML = formatEuro(state.pricing.total);
  }

  /* ──────────────────────────────────────────────────────────
     15. VALIDATION
     ────────────────────────────────────────────────────────── */

  function validateForm() {
    const errors = [];
    if (!state.bike.make)  errors.push('Hersteller');
    if (!state.bike.model) errors.push('Modell');
    if (!state.bike.year)  errors.push('Baujahr');

    ['front','rear'].forEach(pos => {
      const p = pos === 'front' ? 'VR' : 'HR';
      const w = state[pos];
      if (!w.rimFinish)   errors.push(p + ' Felgen-Finish');
      if (!w.rimColor)    errors.push(p + ' Felgenfarbe');
      if (!w.hubMake)     errors.push(p + ' Nabe');
      if (!w.hubFinish)   errors.push(p + ' Naben-Finish');
      if (!w.hubColor)    errors.push(p + ' Nabenfarbe');
      if (!w.spokeType)   errors.push(p + ' Speichentyp');
      if (!w.spokeColor)  errors.push(p + ' Speichenfarbe');
      if (!w.nippleType)  errors.push(p + ' Nippeltyp');
      if (!w.nippleColor) errors.push(p + ' Nippelfarbe');
    });

    const valid = errors.length === 0;
    if (addToCartBtn) addToCartBtn.disabled = !valid;
    if (mobileCartBtn) mobileCartBtn.disabled = !valid;
    if (validationMsg) {
      validationMsg.textContent = valid ? '' : 'Bitte vervollständige: ' + errors.slice(0, 4).join(', ') + (errors.length > 4 ? ' …' : '');
    }
    return valid;
  }

  /* ──────────────────────────────────────────────────────────
     16. BADGES
     ────────────────────────────────────────────────────────── */

  function updateBadges() {
    const bk = state.bike;
    setBadge('wcBikeBadge', bk.make && bk.model && bk.year ? '✓ Komplett' : '');

    ['front','rear'].forEach(pos => {
      const w = state[pos];
      const done = w.rimFinish && w.rimColor && w.hubMake && w.hubFinish && w.hubColor && w.spokeType && w.spokeColor && w.nippleType && w.nippleColor;
      const id = pos === 'front' ? 'wcFrontBadge' : 'wcRearBadge';
      setBadge(id, done ? '✓ Konfiguriert' : '');
    });
  }

  function setBadge(id, text) {
    const el = $('#' + id);
    if (!el) return;
    el.textContent = text;
    el.classList.toggle('is-visible', !!text);
  }

  /* ──────────────────────────────────────────────────────────
     17. VIEWER IFRAME
     ────────────────────────────────────────────────────────── */

  function applyDefaultSelections() {
    ['front','rear'].forEach(pos => {
      const P = pos === 'front' ? 'Front' : 'Rear';
      const w = wheelDefaults();

      // Rim finish
      const rfC = document.querySelector('#wc'+P+'RimFinish [data-option-id="'+w.rimFinish+'"]');
      if (rfC) rfC.setAttribute('aria-checked','true');

      // Rim colors (need to render first)
      renderFinishDependentColors('rim', pos);
      const rcC = document.querySelector('#wc'+P+'RimColors [data-color-id="'+w.rimColor+'"]');
      if (rcC) rcC.setAttribute('aria-checked','true');
      state[pos].rimColor = w.rimColor;

      // Hub make
      const hmC = document.querySelector('#wc'+P+'HubMake [data-option-id="'+w.hubMake+'"]');
      if (hmC) hmC.setAttribute('aria-checked','true');

      // Hub finish
      const hfC = document.querySelector('#wc'+P+'HubFinish [data-option-id="'+w.hubFinish+'"]');
      if (hfC) hfC.setAttribute('aria-checked','true');

      // Hub colors
      renderFinishDependentColors('hub', pos);
      const hcC = document.querySelector('#wc'+P+'HubColors [data-color-id="'+w.hubColor+'"]');
      if (hcC) hcC.setAttribute('aria-checked','true');
      state[pos].hubColor = w.hubColor;

      // Spoke type
      const stC = document.querySelector('#wc'+P+'SpokeTypes [data-option-id="'+w.spokeType+'"]');
      if (stC) stC.setAttribute('aria-checked','true');

      // Spoke color
      const scC = document.querySelector('#wc'+P+'SpokeColors [data-color-id="'+w.spokeColor+'"]');
      if (scC) scC.setAttribute('aria-checked','true');

      // Nipple type
      const ntC = document.querySelector('#wc'+P+'NippleTypes [data-option-id="'+w.nippleType+'"]');
      if (ntC) ntC.setAttribute('aria-checked','true');

      // Nipple color
      const ncC = document.querySelector('#wc'+P+'NippleColors [data-color-id="'+w.nippleColor+'"]');
      if (ncC) ncC.setAttribute('aria-checked','true');
    });
  }

  function setupViewerIframe() {
    if (!viewerFrame) return;
    if (viewerUrl) viewerFrame.src = viewerUrl;
    window.addEventListener('message', onViewerMsg);
  }

  function onViewerMsg(e) {
    if (targetOrigin !== '*' && e.origin !== targetOrigin) return;
    let d;
    try { d = typeof e.data === 'string' ? JSON.parse(e.data) : e.data; } catch(_) { return; }
    if (!d || !d.type) return;

    if (d.type === 'VIEWER_READY') {
      viewerReady = true;
      if (viewerPlaceholder) viewerPlaceholder.classList.add('is-hidden');
      if (viewerFrame) viewerFrame.classList.add('is-ready');
      if (viewerStatusDot) viewerStatusDot.classList.add('is-connected');
      if (viewerStatusText) viewerStatusText.textContent = 'Verbunden';
      flushBuffer();
      sendMsg('CONFIGURATOR_INIT', getFullState());
    } else if (d.type === 'VIEWER_ERROR') {
      if (viewerStatusDot) { viewerStatusDot.classList.remove('is-connected'); viewerStatusDot.classList.add('is-error'); }
      if (viewerStatusText) viewerStatusText.textContent = 'Fehler';
    }
  }

  function sendMsg(type, payload) {
    const msg = { type, payload, timestamp: Date.now() };
    if (!viewerReady) { messageBuffer.push(msg); return; }
    try { viewerFrame?.contentWindow?.postMessage(msg, targetOrigin); } catch(e) { /* */ }
  }

  function flushBuffer() {
    while (messageBuffer.length) {
      try { viewerFrame?.contentWindow?.postMessage(messageBuffer.shift(), targetOrigin); } catch(e) { /* */ }
    }
  }

  function getFullState() {
    return { bike: state.bike, front: state.front, rear: state.rear, pricing: state.pricing };
  }

  /* ──────────────────────────────────────────────────────────
     18. RESET
     ────────────────────────────────────────────────────────── */

  function setupResetButton() {
    const btn = $('#wcResetBtn');
    if (btn) btn.addEventListener('click', resetAll);
  }

  function resetAll() {
    state.bike = { make: '', model: '', year: '' };
    state.front = wheelDefaults();
    state.rear  = wheelDefaults();
    state._skus = {};

    const mk = $('#wcBikeMake'); if (mk) mk.value = '';
    const md = $('#wcBikeModel'); if (md) { md.innerHTML = '<option value="">— Modell wählen —</option>'; md.disabled = true; }
    const yr = $('#wcBikeYear');  if (yr) { yr.innerHTML = '<option value="">— Baujahr wählen —</option>'; yr.disabled = true; }

    $$('.wc__swatch').forEach(s => s.setAttribute('aria-checked', 'false'));
    $$('.wc__pill').forEach(p => p.setAttribute('aria-checked', 'false'));

    // Re-lock finish-dependent color containers
    ['Front','Rear'].forEach(p => {
      ['Rim','Hub'].forEach(c => {
        const cont = $(`#wc${p}${c}Colors`);
        if (cont) { cont.innerHTML = ''; cont.classList.add('wc__swatches--locked'); }
        const hint = $(`#wc${p}${c}ColorHint`);
        if (hint) { hint.classList.remove('is-hidden'); }
      });
    });

    recalculate();
    sendMsg('CONFIGURATOR_INIT', getFullState());
  }

  /* ──────────────────────────────────────────────────────────
     19. CART FORM (no SKUs in line items)
     ────────────────────────────────────────────────────────── */

  function setupCartForm() {
    if (addToCartBtn) addToCartBtn.addEventListener('click', onSubmit);
    if (mobileCartBtn) mobileCartBtn.addEventListener('click', onSubmit);
    const form = $('#wcCartForm');
    if (form) form.addEventListener('submit', onSubmit);
  }

  /* ── Storefront API Config ── */
  const STOREFRONT_TOKEN = '8ba15ffcbeb62deef07cb4ba8f172380';
  const SHOP_DOMAIN      = 'office-6519.myshopify.com';
  const STOREFRONT_URL   = `https://${SHOP_DOMAIN}/api/2025-01/graphql.json`;

  async function storefrontQuery(query, variables) {
    const res = await fetch(STOREFRONT_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
      },
      body: JSON.stringify({ query, variables })
    });
    const json = await res.json();
    if (json.errors) throw new Error(json.errors[0].message);
    return json.data;
  }

  function onSubmit(e) {
    e.preventDefault();
    if (!validateForm()) return;

    const lbl = (list, id) => { const i = list.find(x => x.id === id); return i ? i.label : (id || ''); };

    // Alle Konfigurations-Properties aufbauen
    const customAttributes = [
      { key: 'Bike Hersteller',  value: state.bike.make  || '' },
      { key: 'Bike Modell',      value: state.bike.model || '' },
      { key: 'Bike Baujahr',     value: state.bike.year  || '' },
    ];

    ['front','rear'].forEach(pos => {
      const pre = pos === 'front' ? 'Vorderrad' : 'Hinterrad';
      const w = state[pos];
      customAttributes.push(
        { key: pre + ' Felgenring Finish', value: lbl(rimFinishes, w.rimFinish)       },
        { key: pre + ' Felgenring Farbe',  value: lbl(allRimColors, w.rimColor)       },
        { key: pre + ' Nabe Hersteller',   value: lbl(hubManufacturers, w.hubMake)    },
        { key: pre + ' Nabe Finish',       value: lbl(hubFinishes, w.hubFinish)       },
        { key: pre + ' Nabe Farbe',        value: lbl(allHubColors, w.hubColor)       },
        { key: pre + ' Speichen Typ',      value: lbl(spokeTypes, w.spokeType)        },
        { key: pre + ' Speichen Farbe',    value: lbl(spokeColors, w.spokeColor)      },
        { key: pre + ' Nippel Typ',        value: lbl(nippleTypes, w.nippleType)      },
        { key: pre + ' Nippel Farbe',      value: lbl(nippleColors, w.nippleColor)   }
      );
    });

    customAttributes.push({
      key: '_Konfigurations-JSON',
      value: JSON.stringify({ bike: state.bike, front: state.front, rear: state.rear, pricing: state.pricing })
    });
    customAttributes.push({
      key: 'Gesamtpreis Konfiguration',
      value: formatEuro(state.pricing.total)
    });

    const btn = addToCartBtn;
    if (btn) { btn.textContent = 'Wird berechnet...'; btn.disabled = true; }

    const vid = variantId || $('#wcVariantId')?.value;
    // Shopify Storefront erwartet Global ID (base64)
    const gid = vid.startsWith('gid://') ? vid : `gid://shopify/ProductVariant/${vid}`;

    // Gesamtpreis in EUR als String
    const totalPrice = state.pricing.total.toFixed(2);

    const mutation = `
      mutation cartCreate($input: CartInput!) {
        cartCreate(input: $input) {
          cart {
            checkoutUrl
          }
          userErrors {
            field
            message
          }
        }
      }
    `;

    const variables = {
      input: {
        lines: [
          {
            quantity: 1,
            merchandiseId: gid,
            // Preis-Override über sellingPlanAllocation geht nicht direkt —
            // wir nutzen attributes um den Preis mitzugeben
            attributes: customAttributes
          }
        ],
        attributes: [
          { key: '_konfigurator_total', value: totalPrice },
          { key: '_konfigurator_version', value: '1.0' }
        ]
      }
    };

    // Normaler cart/add — Cart Transform Function übernimmt den Preis
    const props = {};
    customAttributes.forEach(a => { props[a.key] = a.value; });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: vid, quantity: 1, properties: props })
    })
    .then(r => { if (!r.ok) throw new Error('Cart error'); return r.json(); })
    .then(() => {
      window.location.href = '/cart';
    })
    .catch(err => {
      console.error('[WC] Cart error:', err);
      if (validationMsg) validationMsg.textContent = 'Fehler beim Hinzufügen. Bitte erneut versuchen.';
    })
    .finally(() => {
      if (btn) { btn.disabled = false; btn.textContent = 'In den Warenkorb'; }
    });
  }

  /* ── BOOT ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();